// Dedicated case-studies page — mounts the same <CaseStudies /> section
// used previously on the landing page. Anchor links point to individual
// stories so the Trust Bar (LKQ · PV Automotive · TIER · Dott) can deep-link.
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../contexts/LangContext";
import CaseStudies from "../components/CaseStudies";
import SEOHead from "../components/SEOHead";

export default function CaseStudiesPage() {
  const { t } = useLang();
  const ct = t.case_studies || {};
  return (
    <div data-testid="case-studies-page">
      <SEOHead
        title="Fallstudien & Referenzen — Talkani Hamburg"
        description="Echte Aufträge aus Hamburg und Norddeutschland: Autoteile-Distribution für LKQ und PV Automotive, E-Scooter-Nachtservice für TIER und Dott, Umzüge, Reinigungen und Regenrinnenreinigung — inklusive konkreter Zahlen und Video-Doku."
      />

      {/* Back-to-home hint bar */}
      <div className="bg-neutral-50 border-b border-neutral-200 py-3">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-neutral-500 hover:text-[#FF5A00] transition-colors"
            data-testid="case-studies-back-home"
          >
            <ArrowLeft size={12} /> {ct.back_home || "Zurück zur Startseite"}
          </Link>
        </div>
      </div>

      {/* Reuse existing section — already has KPI strip + 5 case cards */}
      <CaseStudies />
    </div>
  );
}
